import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Date from '../../../shared/text/Date';
import './OpenItem.css';
import SimpleTruncate from '../../../shared/text/SimpleTruncate';

class OpenItem extends Component {
  static openItemPropType = {
    id: PropTypes.number.isRequired,
    critical: PropTypes.bool,
    description: PropTypes.string.isRequired,
    dueDate: PropTypes.string.isRequired,
    letter: PropTypes.string.isRequired,
    resolvedNote: PropTypes.string,
    status: PropTypes.oneOf(['incomplete', 'complete']).isRequired,
    updatedAt: PropTypes.string.isRequired,
  };

  static propTypes = {
    item: PropTypes.shape(OpenItem.openItemPropType).isRequired,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    critical: false,
  };

  handleClick = (event) => {
    event.preventDefault();
    if (this.props.onClick !== undefined) {
      this.props.onClick(this.props.item.id);
    }
  };

  render() {
    return (
      <div className="open-item">
        <div className="selection" onClick={this.handleClick}>
          <span>{`${this.props.item.letter}${
            this.props.item.critical ? ' (Critical)' : ''
          }: ${this.props.item.description}`}</span>
          {this.props.item.status === 'incomplete' ? (
            <Date
              className={this.props.item.status}
              value={this.props.item.dueDate}
              format="LL"
            />
          ) : (
            <span className={this.props.item.status}>
              {this.props.item.status}
            </span>
          )}
        </div>
        <div className="selection" onClick={this.handleClick}>
          <Date value={this.props.item.updatedAt} format="hh:mm LL" />
          {this.props.item.status === 'incomplete' && (
            <div className="button-container">
              <input
                className="btn button button-orange"
                type="button"
                value="Respond"
              />
            </div>
          )}
        </div>
        {this.props.item.status === 'complete' &&
          this.props.item.resolvedNote !== undefined &&
          this.props.item.resolvedNote !== null && (
            <div>
              <SimpleTruncate text={this.props.item.resolvedNote} />
            </div>
          )}
      </div>
    );
  }
}

export default OpenItem;



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/OpenItem.js